import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import { IRColheitasColhedor } from '../../../shared/services/api/ColheitasService';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

async function RConheitasporColhedor(data: IRColheitasColhedor[], periodo: string) {
  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = () => reject(`Não foi possível carregar a imagem de ${url}`);
      img.src = url;
    });
  }

  const imageUrl = './logo.png';  
  const imageData = await getBase64ImageFromUrl(imageUrl).catch(() => '');

  if (!imageData.startsWith('data:image')) {
    console.error('Erro na conversão da imagem para base64.');
    return;
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    content: [
      {
        table: {
          widths: [20, '*'],
          body: [
            [
              { image: imageData, width: 30, margin: [0, 15, 0, 0], border: [false, false, false, false] },
              {
                text: 'Relatório de Colheitas',
                fontSize: 20,
                bold: true,
                alignment: 'center',
                border: [false, false, false, true],
                margin: [0, 15, 0, 0],
                borderColor: ['#000000', '#000000', '#000000', '#005e1f'],
                borderWidth: [0, 0, 0, 2],
              },
            ],
          ],
        },
      },
      { text: periodo, margin: [0, 15, 0, 10], alignment: 'left', fillColor: '#dddddd', fontSize: 12 },
      ...data.flatMap((e) => [
        {table: {
          widths: [230, 70],   
          margin: [0, 15, 0, 0],
          
          body: [
            [
              {text: '',  border: [false, false, false, false]},   
              {text: '',  border: [false, false, false, false]},   
            ],
            [
              {text: 'Colhedor',  fillColor: '#dddddd', alignment: 'left', fontSize: 10},
              {text: 'Quantidade', fillColor: '#dddddd', alignment: 'center', fontSize: 10},
              
            ],
            [
              { text: e.colhedor.nome,  alignment: 'left', fontSize: 12, border: [true, true, true, false]},
              { 
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(e.colhedor.quantidade) || 0), 
                alignment: 'right', 
                fontSize: 12,
                border: [true, true, true, false],
                bold: true,
              },  
            ],
            
            // [
            //   {text: '',  border: [false, false, false, false]},   
            //   {text: '',  border: [false, false, false, false]},   
            // ]
           ],
          },
        },
        ...e.areas.map((area) => ({  
          table: {
            widths: [60, 161, 70],        
            margin: [0, 15, 0, 0],
            body: [
              [
                { text: 'Area: '+ area.area, colSpan: 2, fillColor: '#dddddd', alignment: 'left', fontSize: 10 },
                {text: '',  border: [false, false, false, false]},   
                { 
                  text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(area.quantidade) || 0), 
                  alignment: 'right', 
                  fillColor: '#dddddd',
                  fontSize: 10,
                  bold: true,
                },
              ],
              ...area.quadras.map((quadra) => [
                {text: moment(quadra.datalan).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 9},
                { text: "Quadra: "+ quadra.quadra, alignment: 'center', fontSize: 10 },
                { 
                  text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(quadra.quantidade) || 0), 
                  alignment: 'right', 
                  fontSize: 9 
                },
              ],),
              // [
              //   {text: '',  border: [false, false, false, false]},   
              //   {text: '',  border: [false, false, false, false]},   
              // ],
              // [
              //   {text: '',  border: [false, false, false, false]},   
              //   {text: '',  border: [false, false, false, false]},   
              // ],
            ],
          },
        })),
      ]),
    ],
  };

  pdfMake.createPdf(documentDefinition).open(); 
}

export default RConheitasporColhedor;


